import React, { useState, useEffect, useRef, useCallback } from "react";
import $ from "jquery";
import _ from "lodash";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
// import InputRange from 'react-input-range';
import TopNav from "../../commonUI/TopHeader/TopHeader";
import MavSelectComponent from "../Mavs/MavSelectComponent";
import { setJob } from "../../../services/adminService";
import { retrieveJob } from "../../../services/jobService";
import {
  modal,
  select,
  confirm,
  showSpinner,
  closeSpinner,
} from "../../../js/modules/Dialogs";
import { findAddress, addressAutoComplete } from "../../../services/geoService";
import {
  sessionExpired,
  adminResumeJob,
  adminPauseJob,
  adminResumeNotice,
  adminPauseNotice,
  adminSaveChangesConfirm,
  adminReassignConfirm,
  adminJobAlreadyPaidStatus,
  adminJobAlreadyClosed,
  adminJobAlreadyPaid,
  adminJobAlreadyComplete,
  adminJobAlreadyPaidSetClosedNotice,
  adminJobAlreadyPaidSetCompleteNotice,
  adminJobReassignmentNotice,
  adminJobRefundApprovedNotice,
  adminJobOpenOther,
  adminJobClosed,
  jobDateInPast,
  jobDateTooFarAheadA,
  jobDateTooFarAheadB,
} from "../../../config/messages";
import {
  serverUrl,
  mavMode,
  userImagesFolder,
  jobImagesFolder,
  thumbSuffix,
  imageFormat,
  defaultAvatarImage,
} from "../../../config/env";
import {
  defaultCommission,
  jobBookMaxFutureDays,
  defaultMessagesFilter,
} from "../../../config/constants";
import { toScreen } from "../../../js/modules/Routing";
import {
  updateState,
  spoofedISOToMoment,
  momentToSpoofedISO,
  getDateAge,
  leftpad,
  calculatePricesWithCommission,
} from "../../../js/modules/Generic";
import AuditNotes from "../../commonUI/AuditNotes";
import PropTypes from "prop-types";
import ReactSlider from "react-slider";
import withNavigate from "../withNavigate";
import {
  BackArrowIcon,
  CopyIcon,
  CopySuccessIcon,
  EditIcon,
  MessageIcon,
  PauseIcon,
  ResumeIcon,
  StarEmptyIcon,
  StarIcon,
  ViewInStripe,
} from "../../commonUI/Icons/SvgIcon";
import QuoteEdit from "../Quotes/QuoteEdit";
import { Box, Drawer } from "@mui/material";
import JobEdit from "./JobEdit";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";

const Job = ({ userDetails, navigate, props }) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [activeTab, setActiveTab] = useState("jobdetails");
  const [activeBoxTab, setActiveBoxTab] = useState("quotes");
  const [filter, setFilter] = useState(
    window.history.state?.usr?.selectedFilter ?? "all",
  );
  const [copiedCreatorId, setCopiedCreatorId] = useState(false);
  const [copiedJobId, setCopiedJobId] = useState(false);
  const [copiedClientId, setCopiedClientId] = useState(false);
  const { jobId } = useParams(); // Get jobId from URL parameters
  const ref = useRef();
  const mavSelectComponentRef = useRef(null);

  // State initialization
  const [jobs, setJobs] = useState({
    loading: true,
    displayDate: "",
    time: "",
    date: "",
    sliderRange: {
      min: 7,
      max: 23,
    },
    creationDate: "",
    originalStatus: "",
    agreedQuotePrice: "",
    agreedCommission: "",
    stripeRefs: "",
    selectedMav: "",
    selectedQuote: "",
    selectedMavUsername: "",
    originalSelectedMav: "",
    originalRefundAuthorisation: false,
    theReview: {
      comment: false,
      stars: false,
    },
    mavPool: false,
    job: {
      _id: "",
      short_id: "",
      notes: [],
      paymentType: "",
      mavPayment: "",
      _creator: {
        short_id: "",
        accountInfo: {
          username: "",
          avatar: "",
        },
      },
      originAddress: {
        formattedAddress: "",
        googleValidated: "",
        placeId: "",
        streetNumber: "",
        streetName: "",
        postCode: "",
        townCityName: "",
        regionName: "",
        countryName: "United Kingdom",
      },
      destinationAddress: {
        formattedAddress: "",
        googleValidated: "",
        placeId: "",
        streetNumber: "",
        streetName: "",
        postCode: "",
        townCityName: "",
        regionName: "",
        countryName: "United Kingdom",
      },
      originDestinationDistance: {
        theDistance: "",
        theDuration: "",
      },
      pagination: {
        page: 1,
        total: 1,
      },
      jobSpec: {
        // LEGACY : V1 job spec
        itemType: "",
        itemName: "",
        itemDescription: "",
        additionalInfo: "",
        date: "",
        time: "",
        itemWeight: "",
        itemWeightExtra: "",
        // LEGACY

        specVersion: false,
        serviceType: false,
        serviceSubType: false,
        serviceDescription: "",
        dateAndTime: {
          type: false,
          days: {
            Monday: false,
            Tuesday: false,
            Wednesday: false,
            Thursday: false,
            Friday: false,
            Saturday: false,
            Sunday: false,
          },
          timeRange: {
            min: 0,
            max: 0,
          },
          standardDate: false,
        },
        serviceChecklist: {
          requirestwo: false,
          involvesstairs: false,
          nonepresentfrom: false,
          nonepresentto: false,
        },
        expectedPrice: false,
        images: [],
        deleteImages: [],
      },
      marketingDescription: "",
      commission: "",
      conversationOpen: false,
      status: "",
      refundRequested: false,
      refundAuthorisation: false,
      isPaused: false,
      quotes: [],
    },
    addressSuggestions: {
      originAddress: {
        one: {
          description: "A place",
        },
      },
      destinationAddress: {
        one: {
          description: "B place",
        },
      },
    },
    loaders: {
      originAddress: false,
      destinationAddress: false,
    },
    stripeRefs: {},
  });

  // Custom updateState function to maintain compatibility
  const updateStateCustom = useCallback((validate, updates, callback) => {
    setJobs((prevState) => {
      const newState = { ...prevState };

      Object.keys(updates).forEach((key) => {
        if (key.includes(".")) {
          _.set(newState, key, updates[key]);
        } else {
          newState[key] = updates[key];
        }
      });

      return newState;
    });

    if (callback) {
      setTimeout(callback, 0);
    }
  }, []);

  const setLoader = useCallback((loaderName, flag) => {
    setJobs((prevState) => ({
      ...prevState,
      loaders: {
        ...prevState.loaders,
        [loaderName]: flag,
      },
    }));
  }, []);

  const setDatesTimes = useCallback(() => {
    let newState = {};
    let newMom;

    if (
      jobs.job?.jobSpec?.dateAndTime?.type === "today" ||
      jobs.job?.jobSpec?.dateAndTime?.type === "thisweek"
    ) {
      if (jobs.job?.jobSpec?.dateAndTime?.standardDate) {
        newMom = spoofedISOToMoment(
          jobs.job?.jobSpec?.dateAndTime?.standardDate,
        );
      } else {
        newMom = moment(new Date()).hour(12).minute(0).second(0).millisecond(0);
      }
    } else if (jobs.job?.jobSpec?.dateAndTime?.type === "tomorrow") {
      if (jobs.job?.jobSpec?.dateAndTime?.standardDate) {
        newMom = spoofedISOToMoment(
          jobs.job?.jobSpec?.dateAndTime?.standardDate,
        );
      } else {
        newMom = moment(new Date())
          .add(1, "days")
          .hour(12)
          .minute(0)
          .second(0)
          .millisecond(0);
      }
    } else if (jobs.job?.jobSpec?.dateAndTime?.type === "specificdate") {
      if (jobs.job?.jobSpec?.dateAndTime?.standardDate) {
        newMom = spoofedISOToMoment(
          jobs.job?.jobSpec?.dateAndTime?.standardDate,
        );
      } else {
        newMom = moment(new Date())
          .add(1, "days")
          .hour(9)
          .minute(0)
          .second(0)
          .millisecond(0);
      }
    } else if (jobs.job?.jobSpec?.dateAndTime?.type === "notsure") {
      newMom = moment(new Date()).hour(12).minute(0).second(0).millisecond(0);
    }

    if (
      jobs.job?.jobSpec?.dateAndTime?.type === "tomorrow" ||
      jobs.job?.jobSpec?.dateAndTime?.type === "thisweek"
    ) {
      if (
        !jobs.job?.jobSpec?.dateAndTime?.timeRange?.min ||
        !jobs.job?.jobSpec?.dateAndTime?.timeRange?.max
      ) {
        newState["job.jobSpec.dateAndTime.timeRange.min"] = 7;
        newState["job.jobSpec.dateAndTime.timeRange.max"] = 23;
      }

      newState["sliderRange.min"] = 7;
      newState["sliderRange.max"] = 23;
    } else if (jobs.job?.jobSpec?.dateAndTime?.type === "today") {
      let timeRangeMom = moment(new Date()).add(1, "hours");

      if (
        !jobs.job?.jobSpec?.dateAndTime?.timeRange?.min ||
        !jobs.job?.jobSpec?.dateAndTime?.timeRange?.max
      ) {
        newState["job.jobSpec.dateAndTime.timeRange.min"] = 7;
        newState["job.jobSpec.dateAndTime.timeRange.max"] = 23;
      } else {
        newState["job.jobSpec.dateAndTime.timeRange.min"] = parseInt(
          jobs.job?.jobSpec?.dateAndTime?.timeRange?.min,
        );
        newState["job.jobSpec.dateAndTime.timeRange.max"] = parseInt(
          jobs.job?.jobSpec?.dateAndTime?.timeRange?.max,
        );
      }

      newState["sliderRange.min"] = 7;
      newState["sliderRange.max"] = 23;
    }

    if (jobs.job?.jobSpec?.dateAndTime?.type !== "notsure") {
      newState["job.jobSpec.dateAndTime.standardDate"] =
        momentToSpoofedISO(newMom);
      newState["date"] = newMom.format("YYYY-MM-DD");
      newState["time"] = newMom.format("HH:mm");
    }

    updateStateCustom(false, newState, () => {
      $(".input-range__track--active").after(
        '<div class="input-range__track--stripes"></div>',
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step1",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step2",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step3",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step4",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step5",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step6",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step7",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step8",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step9",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step10",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step11",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step12",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step13",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step14",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step15",
      );
      $(".input-range__track--stripes").removeClass(
        "input-range__track--stripes--step16",
      );
      $(".input-range__track--stripes").addClass(
        "input-range__track--stripes--step" +
          (jobs.sliderRange.max - jobs.sliderRange.min),
      );
    });
  }, [jobs.job, jobs.sliderRange, updateStateCustom]);

  const toggleButton = useCallback(
    (event, theTarget) => {
      if (event) {
        event.preventDefault();
      }

      if (jobs.originalStatus === "closed" && name !== "job.status") {
        modal(adminJobAlreadyClosed);
      } else if (jobs.originalStatus === "complete" && name !== "job.status") {
        modal(adminJobAlreadyComplete);
      } else if (
        jobs.originalStatus === "paid" &&
        name !== "job.status" &&
        name !== "selectedMav"
      ) {
        modal(adminJobAlreadyPaid);
        // STATUS CHANGES
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "open" &&
        value !== "open" &&
        value !== "closed"
      ) {
        modal(adminJobOpenOther);
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "closed" &&
        value !== "closed"
      ) {
        modal(adminJobClosed);
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "complete" &&
        value !== "complete"
      ) {
        modal(adminJobAlreadyComplete);
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "paid" &&
        value !== "paid" &&
        value !== "complete" &&
        value !== "closed"
      ) {
        modal(adminJobAlreadyPaidStatus);
      } else {
        updateStateCustom(
          false,
          { [theTarget]: _.get(jobs, theTarget) === true ? false : true },
          () => {},
        );
      }
    },
    [jobs.originalStatus, updateStateCustom, jobs],
  );

  const renderDays = useCallback(
    (key) => {
      const weekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];

      return (
        <div
          className={
            jobs.job?.jobSpec?.dateAndTime?.days[weekDays[key]]
              ? "c-days-select__day c-days-select__day--is-selected"
              : "c-days-select__day"
          }
          onClick={(e) =>
            toggleButton(e, "job.jobSpec.dateAndTime.days." + weekDays[key])
          }
          key={key}
        >
          {weekDays[key].charAt(0)}
        </div>
      );
    },
    [jobs.job, toggleButton],
  );

  const handleSliderChange = useCallback(
    (value) => {
      if (jobs.originalStatus === "closed" && name !== "job.status") {
        modal(adminJobAlreadyClosed);
      } else if (jobs.originalStatus === "complete" && name !== "job.status") {
        modal(adminJobAlreadyComplete);
      } else if (
        jobs.originalStatus === "paid" &&
        name !== "job.status" &&
        name !== "selectedMav"
      ) {
        modal(adminJobAlreadyPaid);
        // STATUS CHANGES
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "open" &&
        value !== "open" &&
        value !== "closed"
      ) {
        modal(adminJobOpenOther);
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "closed" &&
        value !== "closed"
      ) {
        modal(adminJobClosed);
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "complete" &&
        value !== "complete"
      ) {
        modal(adminJobAlreadyComplete);
      } else if (
        name === "job.status" &&
        jobs.originalStatus === "paid" &&
        value !== "paid" &&
        value !== "complete" &&
        value !== "closed"
      ) {
        modal(adminJobAlreadyPaidStatus);
      } else {
        updateStateCustom(
          false,
          {
            "job.jobSpec.dateAndTime.timeRange": {
              min: value[0],
              max: value[1],
            },
          },
          () => {},
        );
      }
    },
    [jobs.originalStatus, updateStateCustom],
  );

  const handleSliderComplete = useCallback((value, theCallback) => {
    // Implementation if needed
  }, []);

  const updateNotes = useCallback(
    (newNotes, theCallback) => {
      if (!_.isEqual(newNotes, jobs.job.notes)) {
        setJobs((prevState) => ({
          ...prevState,
          job: {
            ...prevState.job,
            notes: newNotes,
          },
        }));
        if (theCallback) theCallback();
      } else if (theCallback) {
        theCallback();
      }
    },
    [jobs.job.notes],
  );

  const discardChanges = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }
      toScreen(false, navigate, "/jobs");
    },
    [navigate],
  );

  const mavSelect = useCallback((event) => {
    if (event) {
      event.preventDefault();
    }
    mavSelectComponentRef.current?.goMavSelect();
  }, []);

  const bankTransferComplete = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }

      if (
        jobs.job.status === "complete" &&
        jobs.job.paymentType === "fullpayment" &&
        !jobs.job.mavPayment
      ) {
        setJobs((prevState) => ({
          ...prevState,
          job: {
            ...prevState.job,
            mavPayment: "banktransfercomplete",
          },
        }));
      }
    },
    [jobs.job],
  );

  const approveRejectRefund = useCallback(
    (event, theDecision) => {
      if (event) {
        event.preventDefault();
      }

      if (jobs.job.refundRequested) {
        if (theDecision === "approved") {
          modal(adminJobRefundApprovedNotice, "Refund Approval Notice");
        }
        setJobs((prevState) => ({
          ...prevState,
          job: {
            ...prevState.job,
            refundAuthorisation: theDecision,
          },
        }));
      }
    },
    [jobs.job.refundRequested],
  );

  const selectMav = useCallback((event, theMav, theSelectedMavUsername) => {
    if (event) {
      event.preventDefault();
    }

    select(
      adminReassignConfirm,
      adminJobReassignmentNotice,
      "Cancel",
      "Yes",
      () => {},
      () => {
        setJobs((prevState) => ({
          ...prevState,
          selectedMav: theMav,
          selectedMavUsername: theSelectedMavUsername,
        }));
        mavSelectComponentRef.current?.mavSelect_close();
      },
    );
  }, []);

  const pauseToggle = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }

      if (jobs.job.status === "open") {
        if (jobs.job.isPaused) {
          confirm(adminResumeJob, adminResumeNotice, "Cancel", "Resume", () => {
            setJobs((prevState) => ({
              ...prevState,
              job: {
                ...prevState.job,
                isPaused: false,
              },
            }));
          });
        } else {
          confirm(adminPauseJob, adminPauseNotice, "Cancel", "Pause", () => {
            setJobs((prevState) => ({
              ...prevState,
              job: {
                ...prevState.job,
                isPaused: true,
              },
            }));
          });
        }
      }
    },
    [jobs.job],
  );

  const handleTogglePause = async () => {
    const updatedIsPaused = !jobs.job.isPaused;

    // Optional API call here
    // await updateJobPauseStatus(jobs.job._id, updatedIsPaused);

    setJobs((prev) => ({
      ...prev,
      job: {
        ...prev.job,
        isPaused: updatedIsPaused,
      },
      loaders: {
        ...prev.loaders,
        pauseToggle: false,
      },
    }));
    if (updatedIsPaused) {
      toast.success("Job has been paused");
    } else {
      toast.success("Job has been resumed");
    }
  };

  const setTimeDateV1 = useCallback(
    (event, theTime, theDate) => {
      //LEGACY : V1 jobSpec

      if (event) {
        event.preventDefault();
      }

      var formattedDate;
      var formattedTime;
      var displayDate;
      var newMom;

      if (!theTime && !theDate) {
        formattedDate = "";
        formattedTime = "";
        displayDate = "";
      } else {
        if (theTime === "tomorrow" || theDate === "tomorrow") {
          var newDate = new Date().setHours(9, 0);
          newMom = moment(newDate).add(1, "days");
          formattedDate = newMom.format("DD/MM/YYYY").toLowerCase();
          displayDate = newMom.format("YYYY-MM-DD").toLowerCase();
          formattedTime = newMom.format("HH:mm");
        } else if (theDate === "asap") {
          formattedDate = "asap";
          displayDate = "";
        } else {
          if (!theTime) {
            theTime = jobs.job?.jobSpec?.time;
          }

          if (!theDate) {
            theDate = jobs.displayDate;
          }

          var dateString = theDate + " " + theTime;

          var newDate = new Date(dateString.replace(/-/g, "/"));
          newMom = moment(newDate);
          formattedDate = newMom.format("DD/MM/YYYY").toLowerCase();
          displayDate = newMom.format("YYYY-MM-DD").toLowerCase();
          formattedTime = newMom.format("HH:mm");
        }
        if (formattedDate !== "") {
          if (getDateAge(formattedDate, formattedTime, "minutes") > 0) {
            modal(jobDateInPast);
            var newDate = new Date().setHours(9, 0);
            newMom = moment(newDate).add(1, "days");
            formattedDate = newMom.format("DD/MM/YYYY").toLowerCase();
            displayDate = newMom.format("YYYY-MM-DD").toLowerCase();
            formattedTime = newMom.format("HH:mm");
          } else if (
            getDateAge(formattedDate, formattedTime, "days") <
            jobBookMaxFutureDays
          ) {
            modal(
              jobDateTooFarAheadA +
                jobBookMaxFutureDays * -1 +
                jobDateTooFarAheadB,
            );
            var newDate = new Date().setHours(9, 0);
            newMom = moment(newDate).add(1, "days");
            formattedDate = newMom.format("DD/MM/YYYY").toLowerCase();
            displayDate = newMom.format("YYYY-MM-DD").toLowerCase();
            formattedTime = newMom.format("HH:mm");
          }
        }
      }

      setJobs((prevState) => ({
        ...prevState,
        displayDate: displayDate,
        job: {
          ...prevState.job,
          jobSpec: {
            ...prevState.job?.jobSpec,
            date: formattedDate,
            time: formattedTime,
          },
        },
      }));
    },
    [jobs.job, jobs.displayDate],
  );

  const setTimeDate = useCallback(
    (event, theTarget) => {
      if (event) {
        event.preventDefault();
      }

      const createStandardDate = () => {
        let newMom = moment(
          new Date(jobs.date.replace(/-/g, "/") + " " + jobs.time),
        );

        updateStateCustom(
          false,
          {
            [theTarget]: momentToSpoofedISO(newMom),
          },
          () => {},
        );
      };

      if (jobs.date && jobs.time) {
        let timeSplit = jobs.time.split(":");

        if (
          timeSplit[1] !== "00" &&
          timeSplit[1] !== "15" &&
          timeSplit[1] !== "30" &&
          timeSplit[1] !== "45"
        ) {
          updateStateCustom(
            false,
            {
              time:
                timeSplit[0] +
                ":" +
                leftpad(
                  Math.floor((parseInt(timeSplit[1]) / 60) * 4) * 15,
                  2,
                  "0",
                ),
            },
            () => {
              createStandardDate();
            },
          );
        } else {
          createStandardDate();
        }
      }
    },
    [jobs.date, jobs.time, updateStateCustom],
  );

  const getJob = useCallback(async () => {
    showSpinner();
    try {
      const theJob = {
        accountInfo: {
          username: userDetails.accountInfo.username,
          email: userDetails.accountInfo.email,
        },
        short_id: jobId ?? window.location.pathname?.split("/")[2],
      };

      const resJson = await retrieveJob(theJob);
      closeSpinner();
      getJob_done(200, "", resJson);
    } catch (error) {
      closeSpinner();
      const status = error.response?.status || 500;
      const message = error.response?.data?.message || error.message;
      getJob_done(status, message, {});
    }
  }, [jobId, userDetails, navigate]);

  const getJob_done = useCallback(
    (resStatus, responseString, resJson) => {
      closeSpinner();

      if (resStatus === 401) {
        modal(sessionExpired);
        toScreen(false, navigate, "/logout");
      } else if (resStatus === "400") {
        modal(responseString);
        toScreen(false, navigate, "/jobs");
      } else if (resStatus === 200) {
        let theDisplayDate = "";
        let theDate = "";
        let theTime = "";

        if (
          !resJson.theJob?.jobSpec?.specVersion ||
          resJson.theJob?.jobSpec?.specVersion === 1
        ) {
          if (resJson.theJob?.jobSpec?.date) {
            const newMom = moment.tz(
              `${resJson.theJob?.jobSpec?.date} ${resJson.theJob?.jobSpec?.time}`,
              "Europe/London",
            );
            theDisplayDate = newMom.format("YYYY-MM-DD").toLowerCase();
          }
        } else {
          if (resJson.theJob?.jobSpec?.dateAndTime?.type !== "notsure") {
            const newMom = spoofedISOToMoment(
              resJson.theJob?.jobSpec?.dateAndTime?.standardDate,
            );
            theDate = newMom.format("YYYY-MM-DD").toLowerCase();
            theTime = newMom.format("HH:mm");
          }
        }

        let tmpAgreedQuotePrice = "";
        let tmpAgreedCommission = "";
        let tmpSelectedMav = "";
        let tmpSelectedQuote = "";
        let tmpSelectedMavUsername = "";
        let tmpOriginalSelectedMav = "";
        let tmpTheReview = "";
        let theQuoteId;

        _.forEach(resJson.theJob.payments, (value) => {
          if (value.paymentResponse && value.paymentResponse.id) {
            theQuoteId = value.quote;
          }
        });

        _.forEach(resJson.theJob.quotes, (value) => {
          if (
            theQuoteId === value._id ||
            (resJson?.theJob?.payments?.length === 0 &&
              resJson?.theJob?.payment?.quote === value._id)
          ) {
            const thePrices = calculatePricesWithCommission(
              false,
              value.quoteSpec?.price,
              resJson.theJob.commission || defaultCommission,
              2,
              true,
            );
            tmpAgreedQuotePrice = thePrices.totalPrice;
            tmpAgreedCommission = thePrices.commission;
            tmpSelectedMav = value._creator.short_id;
            tmpSelectedQuote = value.short_id;
            tmpSelectedMavUsername = value._creator.accountInfo.username;
            tmpOriginalSelectedMav = value._creator.short_id;

            if (value.ratings?.[0]?.stars) {
              tmpTheReview = {
                comment: value.ratings[0].comment,
                stars: value.ratings[0].stars,
              };
            }
          }
        });

        setJobs((prev) => ({
          ...prev,
          loading: false,
          creationDate: resJson.theJob.creationDate,
          displayDate: theDisplayDate,
          time: theTime,
          date: theDate,
          originalStatus: resJson.theJob.status,
          selectedMav: tmpSelectedMav,
          selectedQuote: tmpSelectedQuote,
          selectedMavUsername: tmpSelectedMavUsername,
          originalSelectedMav: tmpOriginalSelectedMav,
          theReview: tmpTheReview,
          originalRefundAuthorisation: resJson.theJob.refundAuthorisation,
          agreedQuotePrice: tmpAgreedQuotePrice,
          agreedCommission: tmpAgreedCommission,
          stripeRefs:
            resJson.theJob?.payments?.[resJson.theJob?.payments?.length - 1]
              ?.paymentResponse?.id ??
            resJson.theJob?.payment?.paymentResponse?.paymentChargeId,
          mavPool: resJson.mavPool,
          job: {
            ...resJson.theJob,
            jobSpec: {
              ...resJson.theJob.jobSpec,
              deleteImages: [],
            },
            marketingDescription: resJson.theJob.marketingDescription,
            commission: resJson.theJob.commission,
          },
        }));
      }
    },
    [navigate],
  );

  const saveJob = (event) => {
    if (event) event.preventDefault();

    confirm(false, adminSaveChangesConfirm, "Cancel", "Save", () => {
      showSpinner();

      let theJob = {
        _id: jobs.job._id,
        short_id: jobs.job.short_id,
        notes: jobs.job.notes,
        originAddress: { ...jobs.job.originAddress },
        destinationAddress: { ...jobs.job.destinationAddress },
        selectedMav: jobs.selectedMav,
        mavPayment: jobs.job.mavPayment,
        marketingDescription: jobs.job.marketingDescription,
        status: jobs.job.status,
        refundRequested: jobs.job.refundRequested,
        refundAuthorisation: jobs.job.refundAuthorisation,
        isPaused: jobs.job.isPaused,
      };

      if (
        !jobs.job?.jobSpec?.specVersion ||
        jobs.job?.jobSpec?.specVersion === 1
      ) {
        theJob.jobSpec = {
          ...jobs.job.jobSpec,
          date:
            jobs.job?.jobSpec?.date === "" ? "asap" : jobs.job?.jobSpec?.date,
        };
      } else {
        theJob.jobSpec = {
          ...jobs.job.jobSpec,
        };
      }

      setJob(theJob)
        .then((resJson) => {
          closeSpinner();
          modal(resJson?.message || "Job saved successfully.", false, () => {
            toScreen(false, navigate, "/jobs");
          });
        })
        .catch((error) => {
          closeSpinner();
          if (error.response?.status === 401) {
            modal(sessionExpired);
            toScreen(false, navigate, "/logout");
          } else if (error.response?.status === 400) {
            modal(error.response?.data?.message || "Bad request.");
          } else {
            modal(error.message || "Something went wrong!");
          }
        });
    });
  };

  const findAddress = (event, addressTarget) => {
    if (
      jobs.job[addressTarget]?.placeId &&
      jobs.originalStatus !== "closed" &&
      jobs.originalStatus !== "complete"
    ) {
      if (event) event.preventDefault();

      const theAddress = {
        addressTarget,
        theAddress: { ...jobs.job[addressTarget] },
      };

      findAddress(theAddress, findAddress_done);
    }
  };

  const findAddress_done = (resStatus, responseString, resJson) => {
    if (resStatus === 200) {
      setJobs((prev) => ({
        ...prev,
        job: {
          ...prev.job,
          [resJson.addressTarget]: resJson.theAddress,
        },
      }));
    }
  };

  const handleCreatorIdCopy = () => {
    const shortId = jobs?.job?._creator?.short_id || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setCopiedCreatorId(true);
      setTimeout(() => setCopiedCreatorId(false), 1500);
    }
    toast.success("ID copied to clipboard");
  };

  const handleJobIdCopy = () => {
    const shortId = jobs?.job?.short_id || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setCopiedJobId(true);
      setTimeout(() => setCopiedJobId(false), 1500);
    }
    toast.success("ID copied to clipboard");
  };

  const handleClientIdCopy = () => {
    const shortId = jobs?.job?.short_id || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setCopiedClientId(true);
      setTimeout(() => setCopiedClientId(false), 1500);
    }
    toast.success("ID copied to clipboard");
  };

  useEffect(() => {
    getJob();
  }, []);

  const addressAutoComplete = (event, addressTarget) => {
    event.preventDefault();
    setLoader(addressTarget, true);
    if (
      jobs.job[addressTarget].formattedAddress != "" &&
      (addressTarget === "originAddress" ||
        jobs.job[addressTarget].formattedAddress != "Nearest tip")
    ) {
      setTimeout(() => {
        var theAddress = {
          addressTarget: addressTarget,
          theAddress: { ...jobs.job[addressTarget] },
        };

        addressAutoComplete(theAddress, addressAutoComplete_done);
      }, 100);
    } else {
      setLoader(addressTarget, false);
    }
  };

  const addressAutoComplete_done = (resStatus, responseString, resJson) => {
    if (resStatus == "400" || resStatus == 400) {
      setJobs((prev) => ({
        ...prev,
        addressSuggestions: {
          originAddress: {},
          destinationAddress: {},
        },
      }));
    } else if (resStatus == 200) {
      setJobs((prev) => ({
        ...prev,
        addressSuggestions: {
          ...prev.addressSuggestions,
          [resJson.addressTarget]: resJson.predictions,
        },
      }));
    }
    setLoader(resJson.addressTarget, false);
  };

  const checkSuggestionMatch = (addressTarget, theCallback) => {
    var foundMatch;

    _.forEach(jobs.addressSuggestions[addressTarget], (value, key) => {
      if (value.description === jobs.job[addressTarget].formattedAddress) {
        foundMatch = value;
      }
    });

    if (foundMatch) {
      return setJobs((prev) => ({
        ...prev,
        job: {
          ...prev.job,
          originDestinationDistance: {
            theDistance: "",
            theDuration: "",
          },
          [addressTarget]: {
            ...jobs.job[addressTarget],
            formattedAddress: foundMatch.description,
            googleValidated: "",
            placeId: foundMatch.place_id,
            streetNumber: "",
            streetName: "",
            postCode: "",
            townCityName: "",
            regionName: "",
            countryName: "United Kingdom",
          },
        },
        addressSuggestions: {
          originAddress: {},
          destinationAddress: {},
        },
      }));
    } else if (theCallback) {
      return theCallback();
    }
  };

  const renderQuotes = (key) => {
    const quote = jobs?.job?.quotes[key];

    return (
      <tr key={key}>
        <td className="text-capitalize">
          <a
            href="#"
            className="font-semibold"
            onClick={(e) =>
              toScreen(e, navigate, "/mav/" + quote?._creator?.short_id)
            }
          >
            {quote?._creator?.accountInfo?.username}
          </a>
        </td>
        <td>
          <span
            className={`badge text-capitalize${
              quote?.status === "open" ? " badge-info" : ""
            } ${quote?.status === "complete" ? " badge-success" : ""} ${
              quote?.status === "paid" ? " badge-success" : ""
            } ${quote?.status === "closed" ? "badge-gray" : ""}`}
          >
            {quote?.status === "paid"
              ? "Paid"
              : quote?.status === "open"
                ? "In Progress"
                : quote?.status === "complete"
                  ? "Booked"
                  : quote?.status === "closed"
                    ? "Closed"
                    : j}
          </span>
        </td>

        <td>&pound;{quote?.quoteSpec?.price}</td>
        <td>{quote?.quoteSpec?.message?.message || "-"}</td>

        <td>
          {quote?.creationDate}
          <br />
          <span className="text-sm text-gray-600 ">{quote?.creationTime}</span>
        </td>
        <td>
          <button
            type="button"
            className="custom-btn"
            onClick={(e) => toScreen(e, navigate, "/quote/" + quote.short_id)}
          >
            View Quote
          </button>
        </td>
      </tr>
    );
  };

  const renderMyAddresses = (key, addressTarget) => {
    const address = jobs.addressSuggestions[addressTarget][key];

    return <option value={address.description} key={key} />;
  };

  const handleInputChange = (event, theCallback) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    var oldValue = false;

    const inputChangeCallback = () => {
      if (name === "job.jobSpec.dateAndTime.type") {
        if (oldValue != value) {
          setDatesTimes();
        }
      } else if (name === "job.status") {
        if (jobs.originalStatus == "paid" && value === "closed") {
          modal(adminJobAlreadyPaidSetClosedNotice, "Refund Notice");
        }

        if (jobs.originalStatus == "paid" && value === "complete") {
          modal(adminJobAlreadyPaidSetCompleteNotice, "Payment Notice");
        }

        if (theCallback) {
          theCallback();
        }
      } else if (name == "selectedMav") {
        if (value != jobs.originalSelectedMav) {
          modal(adminJobReassignmentNotice, "Reassignment Notice");
        }

        if (theCallback) {
          theCallback();
        }
      } else if (name === "job.jobSpec.itemWeight" && oldValue != value) {
        setJobs((prev) => ({
          ...prev,
          job: {
            ...prev.job,
            jobSpec: {
              ...prev.job?.jobSpec,
              itemWeightExtra: "",
            },
          },
        }));
      } else if (name === "job.jobSpec.serviceType" && oldValue != value) {
        setJobs((prev) => ({
          ...prev,
          job: {
            ...prev.job,
            jobSpec: {
              ...prev.job?.jobSpec,
              serviceSubType: false,
            },
          },
        }));
      } else if (name === "job.originAddress.formattedAddress") {
        checkSuggestionMatch("originAddress", theCallback);
      } else if (name === "job.destinationAddress.formattedAddress") {
        checkSuggestionMatch("destinationAddress", theCallback);
      } else {
        if (theCallback) {
          theCallback();
        }
      }
    };

    // CONTENT CHANGES
    if (jobs.originalStatus === "closed" && name !== "job.status") {
      modal(adminJobAlreadyClosed);
    } else if (
      jobs.originalStatus === "complete" &&
      name !== "job.status" &&
      name !== "job.marketingDescription"
    ) {
      modal(adminJobAlreadyComplete);
    } else if (
      jobs.originalStatus === "paid" &&
      name !== "job.status" &&
      name !== "selectedMav"
    ) {
      modal(adminJobAlreadyPaid);
      // STATUS CHANGES
    } else if (
      name === "job.status" &&
      jobs.originalStatus === "open" &&
      value !== "open" &&
      value !== "closed"
    ) {
      modal(adminJobOpenOther);
    } else if (
      name === "job.status" &&
      jobs.originalStatus === "closed" &&
      value !== "closed"
    ) {
      modal(adminJobClosed);
    } else if (
      name === "job.status" &&
      jobs.originalStatus === "complete" &&
      value !== "complete"
    ) {
      modal(adminJobAlreadyComplete);
    } else if (
      name === "job.status" &&
      jobs.originalStatus === "paid" &&
      value !== "paid" &&
      value !== "complete" &&
      value !== "closed"
    ) {
      modal(adminJobAlreadyPaidStatus);
    } else if (name.split(".").length == 1) {
      oldValue = jobs[name];

      setJobs(
        {
          [name]: value,
        },
        inputChangeCallback,
      );
    }
  };

  const handleInputBlur = (event, theCallback) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (
      name === "job.originAddress.formattedAddress" ||
      name === "job.destinationAddress.formattedAddress"
    ) {
      setJobs(
        {
          ...jobs,
          addressSuggestions: {
            originAddress: {},
            destinationAddress: {},
          },
        },
        theCallback,
      );
    } else if (theCallback) {
      return theCallback();
    }
  };

  const deleteImage = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (jobs.originalStatus === "closed") {
      modal(adminJobAlreadyClosed);
    } else if (jobs.originalStatus === "complete") {
      modal(adminJobAlreadyComplete);
    } else if (jobs.originalStatus === "paid") {
      modal(adminJobAlreadyPaid);
    } else {
      var newDeleteImages = jobs.job?.jobSpec?.deleteImages.slice(0);
      var newImages = jobs.job?.jobSpec?.images.slice(0);

      if (newDeleteImages.indexOf(parseInt(event.target.value)) == -1) {
        newDeleteImages.push(parseInt(event.target.value));
      }

      if (newImages.indexOf(parseInt(event.target.value)) != -1) {
        newImages.splice(newImages.indexOf(parseInt(event.target.value)), 1);
      }

      setJobs({
        job: {
          ...jobs.job,
          jobSpec: {
            ...jobs.job?.jobSpec,
            deleteImages: newDeleteImages,
            images: newImages,
          },
        },
      });
    }
  };

  const toggleDrawer =
    (anchor, open, view = null, jobs = null) =>
    (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      setState({ ...jobs, [anchor]: open });

      if (open) {
        setCurrentView(view);
        if (jobs) {
          setSelectedJob(jobs);
        } else {
          setSelectedJob(null);
        }
      }
    };

  const list = (anchor) => (
    <Box
      sx={{ width: 600 }}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <JobEdit
        view={currentView}
        onClose={toggleDrawer(anchor, false)}
        userDetails={userDetails}
        jobs={selectedJob}
      />
    </Box>
  );

  const renderImages = (key) => {
    const image = jobs?.job?.jobSpec?.images[key];

    return (
      <img
        key={key}
        src={
          serverUrl +
          jobImagesFolder +
          "/" +
          jobs.job.short_id +
          "/" +
          image +
          thumbSuffix +
          imageFormat
        }
        alt={"image " + image}
        className="c-avatar__pic"
      />
    );
  };

  const getAvatarSrc = useCallback((jobs) => {
    if (
      jobs?.job._creator?.accountInfo?.avatar &&
      jobs?.job._creator?.accountInfo?.avatar !== ""
    ) {
      return `${serverUrl}${userImagesFolder}/${jobs?.job._creator?.short_id}/${jobs?.job._creator?.accountInfo?.avatar}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${defaultAvatarImage}${imageFormat}`;
  }, []);

  return (
    <>
      {jobs.loading === true ? (
        <>
          <TopNav title={"Job details:"} shortId={jobs.job.short_id} />
        </>
      ) : (
        <>
          <TopNav title={"Job details:"} shortId={jobs.job.short_id} />

          <div className="global-body">
            <div className="global-body-container">
              <>
                <button
                  className="btn-outline-light icon-with-btn"
                  onClick={() => navigate("/jobs")}
                >
                  <BackArrowIcon />
                  Back to Jobs
                </button>
                <div className="card client-card mt-16 mb-24">
                  <div>
                    <h3 className="fw-semibold mb-4 text-capitalize">
                      {jobs.job.jobSpec?.serviceType}
                    </h3>
                    <div className="d-flex align-items-center g-8 mb-4">
                      <button
                        onClick={handleCreatorIdCopy}
                        className="badge copyCode-btn"
                      >
                        {jobs?.job?._creator?.short_id?.toUpperCase()}

                        {copiedCreatorId ? <CopySuccessIcon /> : <CopyIcon />}
                      </button>

                      <div className="d-flex align-items-center g-4">
                        <span
                          className={`badge text-capitalize${
                            jobs?.job?.status === "open" ? " badge-info" : ""
                          } ${
                            jobs?.job?.status === "complete"
                              ? " badge-success"
                              : ""
                          } ${
                            jobs?.job?.status === "paid" ? " badge-success" : ""
                          } ${
                            jobs?.job?.status === "closed" ? "badge-gray" : ""
                          }`}
                        >
                          {jobs?.job?.status === "paid"
                            ? "Paid"
                            : jobs?.job?.status === "open"
                              ? "In Progress"
                              : jobs?.job?.status === "complete"
                                ? "Booked"
                                : jobs?.job?.status === "closed"
                                  ? "Closed"
                                  : j}
                        </span>
                        <span
                          className={`badge ${
                            jobs.job?.isPaused ? "badge-orange" : "d-none"
                          }`}
                        >
                          {jobs.job?.isPaused === true ? "Paused" : ""}
                        </span>
                      </div>
                    </div>
                    <div className="text-sm text-gray-500 text-capitalize">
                      <span>Posted by: </span>
                      <a
                        // href="/clients/CLT54321"
                        className=""
                      >
                        {jobs?.job?._creator?.accountInfo?.username}
                      </a>
                      <span className="text-sm text-gray-400 mx-4">•</span>
                      <span>
                        Posted on: {jobs?.job?.creationDate},{" "}
                        {jobs?.job?.creationTime}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center g-12 ms-auto">
                    <button
                      // className="btn btn-warning-light icon-with-btn"
                      className={`btn icon-with-btn ${
                        jobs.job?.isPaused
                          ? "btn-success-light"
                          : "btn-warning-light"
                      }`}
                      onClick={handleTogglePause}
                    >
                      {jobs.job?.isPaused ? <ResumeIcon /> : <PauseIcon />}
                      {jobs.job?.isPaused ? "Resume Job" : "Pause Job"}
                    </button>

                    <button
                      className="btn-outline-light icon-with-btn"
                      onClick={(e) =>
                        toScreen(
                          e,
                          navigate,
                          "/message/" + jobs.job?.short_id,
                          false,
                          {
                            receiverId: jobs.job?._id,
                            receiverShortId: jobs.job?.short_id,
                            receiverType: jobs.job?.userType,
                            userShortId1: "admin",
                            userShortId2: jobs.job?.short_id,
                            username2: jobs.job?.accountInfo?.username,
                            selectedPage:
                              window.history.jobs.usr?.selectedPage ?? 1,
                            selectedFilter:
                              window.history.jobs.usr?.selectedFilter ??
                              defaultMessagesFilter,
                            previousPath:
                              window.history.jobs.usr?.previousPath ??
                              window.location.pathname,
                          },
                        )
                      }
                    >
                      <MessageIcon />
                      Message {jobs?.job?.accountInfo?.firstname}
                    </button>
                    {["right"].map((anchor) => (
                      <React.Fragment key={anchor}>
                        <button
                          className="btn-warning icon-with-btn"
                          onClick={toggleDrawer(anchor, true, "edit", jobs)}
                        >
                          <EditIcon />
                          Edit
                        </button>
                        <Drawer
                          anchor={anchor}
                          open={state[anchor]}
                          onClose={toggleDrawer(anchor, false)}
                          ModalProps={{
                            BackdropProps: {
                              style: {
                                backgroundColor: "rgba(0, 0, 0, 0.1)",
                              },
                            },
                          }}
                          sx={{
                            boxShadow: "none",
                            "& .MuiDrawer-paper": { boxShadow: "none" },
                          }}
                        >
                          {list(anchor)}
                        </Drawer>
                      </React.Fragment>
                    ))}
                  </div>
                </div>

                <section className="tabing-section mt-16">
                  {/* Left Side Content */}
                  <div className="tab-content">
                    <div className="card mb-24 py-16">
                      <ul className="d-flex align-items-center justify-content-between">
                        <li>
                          <span className="text-sm text-gray-500 d-block">
                            Quote Range
                          </span>
                          <h5 className="fw-semibold mb-0 text-lg">
                            {jobs?.job?.totalSpent || "£180 - £240"}
                          </h5>
                        </li>
                        <li>
                          <span className="text-sm text-gray-500 d-block">
                            Total Quotes
                          </span>
                          <h5 className="fw-semibold mb-0 text-lg">
                            {jobs?.job?.totalJobs || 0}
                          </h5>
                        </li>
                        <li>
                          <span className="text-sm text-gray-500 d-block">
                            Quotes Dismissed
                          </span>
                          <h5 className="fw-semibold mb-0 text-lg">
                            {jobs?.job?.activeJobs || 0}
                          </h5>
                        </li>
                      </ul>
                    </div>
                    <div className="mb-24 modal-card">
                      <div className="custom-tabs m-0">
                        <div
                          className={`tab-item ${
                            activeBoxTab === "booked" ? "active" : ""
                          }`}
                          onClick={() => setActiveBoxTab("booked")}
                        >
                          Booked Driver
                        </div>
                        <div
                          className={`tab-item ${
                            activeBoxTab === "quotes" ? "active" : ""
                          }`}
                          onClick={() => setActiveBoxTab("quotes")}
                        >
                          Quotes
                        </div>
                      </div>
                      {activeBoxTab === "booked" && (
                        <>
                          <div className="quote-profile">
                            <div className="d-flex align-items-center g-12">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <img
                                    src={getAvatarSrc(jobs)}
                                    alt="avatar"
                                    className="avatar-pic"
                                    onError={(e) => {
                                      e.target.src = defaultAvatarImage;
                                    }}
                                  />
                                  <div>
                                    <h4 className="mb-0 text-lg text-capitalize">
                                      {jobs.job._creator.username ||
                                        "Michael Johnson"}
                                    </h4>
                                    <button
                                      onClick={handleJobIdCopy}
                                      className="badge copyCode-btn"
                                    >
                                      {jobs?.job?.short_id?.toUpperCase()}

                                      {copiedJobId ? (
                                        <CopySuccessIcon />
                                      ) : (
                                        <CopyIcon />
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center g-12 ms-auto">
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={(e) =>
                                  toScreen(
                                    e,
                                    navigate,
                                    "/message/" + jobs.job?._creator?.short_id,
                                    false,
                                    {
                                      receiverId: jobs.job?._id,
                                      receiverShortId:
                                        jobs.job?._creator?.short_id,
                                      receiverType: jobs.job?.userType,
                                      userShortId1: "admin",
                                      userShortId2: jobs.job?.short_id,
                                      username2:
                                        jobs.job?.accountInfo?.username,
                                      selectedPage:
                                        window.history.jobs.usr?.selectedPage ??
                                        1,
                                      selectedFilter:
                                        window.history.jobs.usr
                                          ?.selectedFilter ??
                                        defaultMessagesFilter,
                                      previousPath:
                                        window.history.jobs.usr?.previousPath ??
                                        window.location.pathname,
                                    },
                                  )
                                }
                              >
                                <MessageIcon />
                                {jobs.job?.accountInfo?.firstname}
                              </button>
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={(e) =>
                                  toScreen(
                                    e,
                                    navigate,
                                    `/client/${jobs.job?._creator?.short_id}`,
                                  )
                                }
                              >
                                Details
                              </button>
                            </div>
                          </div>
                          <div className="p-24">
                            <ul className="profile-info">
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Booked on
                                </span>
                                <p>Jun 18, 2023, at 05:30</p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Stripe payment reference
                                </span>
                                <p>
                                  {" "}
                                  {jobs?.job?.payment?.paymentResponse?.id &&
                                  jobs?.job?.payment?.paymentResponse?.id !=
                                    "" ? (
                                    <a
                                      href={
                                        "https://dashboard.stripe.com/customers/" +
                                        jobs?.job?.payment?.paymentResponse?.id
                                      }
                                      className="anchor-primary-link"
                                      target="_blank"
                                    >
                                      {jobs?.job?.payment?.paymentResponse?.id}
                                    </a>
                                  ) : (
                                    "N/A"
                                  )}
                                </p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Client paid
                                </span>
                                <p>
                                  {jobs.job?.accountInfo?.surname || "£220.00"}
                                </p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Payment type
                                </span>
                                <p>
                                  {jobs.job?.accountInfo?.username ||
                                    "Full payment"}
                                </p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  MAV commission (20%)
                                </span>
                                <p>
                                  {jobs.job?.accountInfo?.email || "£44.00"}
                                </p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Driver quoted
                                </span>
                                <p>
                                  {jobs.job?.accountInfo?.email || "£220.00"}
                                </p>
                              </li>{" "}
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Driver Payment status
                                </span>
                                <p>
                                  {jobs.job?.accountInfo?.email || "Pending"}
                                </p>
                              </li>
                            </ul>
                            <div className="client-review">
                              <h3 className="text-sm mb-8">Client review</h3>

                              <div className="client-review-item">
                                <StarIcon />
                                <p className="text-sm review-content">
                                  "Michael was absolutely fantastic! He arrived
                                  on time, was extremely careful with all our
                                  belongings, and went above and beyond to make
                                  our move stress-free. The piano was handled
                                  with expert care, and he even helped us
                                  arrange furniture in the new place. Would
                                  definitely recommend and use again!"
                                </p>
                                <p className="review-name">
                                  — Sarah Thompson, Jun 20, 2023 at 6:30 PM
                                </p>{" "}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {activeBoxTab === "quotes" &&
                        (jobs.job?.quotes?.length > 0 ? (
                          <div className="table-responsive border-0">
                            <table className="table clientTable jobDetailsTable">
                              <thead>
                                <tr>
                                  <th>
                                    <button className="p-0 cursor-default">
                                      Driver
                                    </button>
                                  </th>
                                  <th>
                                    <button className="p-0 cursor-default">
                                      Status
                                    </button>
                                  </th>
                                  <th>
                                    <button className="p-0 cursor-default">
                                      Total Amount
                                    </button>
                                  </th>
                                  <th>
                                    <button className="p-0 cursor-default">
                                      Message
                                    </button>
                                  </th>
                                  <th>
                                    <button className="p-0 cursor-default">
                                      Quoted On
                                    </button>
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.keys(jobs.job?.quotes)?.map(
                                  renderQuotes,
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <span className="text-danger">
                            {`No quotes found for this job (${jobs.job?.short_id})`}
                          </span>
                        ))}
                    </div>

                    <div className="modal-card">
                      <div className="custom-tabs m-0">
                        <div
                          className={`tab-item ${
                            activeTab === "jobdetails" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("jobdetails")}
                        >
                          Job details
                        </div>
                        <div
                          className={`tab-item ${
                            activeTab === "client" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("client")}
                        >
                          Client details
                        </div>
                      </div>
                      <div>
                        {/* Profile Info */}
                        {activeTab === "jobdetails" && (
                          <>
                            <div className="quote-profile">
                              <div className="d-flex align-items-center g-12">
                                <div>
                                  <div className="d-flex align-items-center g-8">
                                    <h4 className="mb-0 text-lg text-capitalize">
                                      {jobs.job._creator.accountInfo.username}
                                    </h4>
                                    <span
                                      className={`text-capitalize badge  ${
                                        jobs.job?.status === "open"
                                          ? "badge-info"
                                          : jobs.job?.status === "closed"
                                            ? "badge-danger"
                                            : jobs.job?.status === "paid"
                                              ? "badge-warning"
                                              : jobs.job?.status === "complete"
                                                ? "badge-success"
                                                : ""
                                      }`}
                                    >
                                      {jobs.job?.status}
                                    </span>
                                  </div>

                                  <p className="text-sm text-gray-600 text-capitalize">
                                    <button
                                      onClick={handleJobIdCopy}
                                      className="badge copyCode-btn"
                                    >
                                      {jobs?.job?.short_id?.toUpperCase()}

                                      {copiedJobId ? (
                                        <CopySuccessIcon />
                                      ) : (
                                        <CopyIcon />
                                      )}
                                    </button>
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex align-items-center g-12 ms-auto">
                                {["right"].map((anchor) => (
                                  <React.Fragment key={anchor}>
                                    <button
                                      className="btn-warning icon-with-btn"
                                      onClick={toggleDrawer(
                                        anchor,
                                        true,
                                        "edit",
                                        jobs,
                                      )}
                                    >
                                      <EditIcon />
                                      Edit
                                    </button>
                                    <Drawer
                                      anchor={anchor}
                                      open={jobs[anchor]}
                                      onClose={toggleDrawer(anchor, false)}
                                      ModalProps={{
                                        BackdropProps: {
                                          style: {
                                            backgroundColor:
                                              "rgba(0, 0, 0, 0.1)",
                                          },
                                        },
                                      }}
                                      sx={{
                                        boxShadow: "none",
                                        "& .MuiDrawer-paper": {
                                          boxShadow: "none",
                                        },
                                      }}
                                    >
                                      {list(anchor)}
                                    </Drawer>
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                            <div className="p-24">
                              <div className="job-images">
                                {Object.keys(jobs?.job?.jobSpec?.images).map(
                                  renderImages,
                                )}
                              </div>
                              <ul className="profile-info">
                                <li className="profile-info-item item-full">
                                  <span className="profile-info-title">
                                    Description
                                  </span>
                                  <p>
                                    Moving from a 2-bedroom flat to a new house.
                                    Includes furniture, boxes, and a piano that
                                    requires special handling.
                                  </p>
                                </li>

                                <li className="profile-info-item">
                                  <span className="profile-info-title">
                                    From
                                  </span>
                                  <p>
                                    {jobs.job?.accountInfo?.firstname || "-"}
                                  </p>
                                </li>
                                <li className="profile-info-item">
                                  <span className="profile-info-title">To</span>
                                  <p>{jobs.job?.accountInfo?.surname || "-"}</p>
                                </li>
                                <hr />
                                <li className="profile-info-item">
                                  <span className="profile-info-title">
                                    Posted on
                                  </span>
                                  <p>
                                    {jobs.job?.accountInfo?.username || "-"}
                                  </p>
                                </li>
                                <li className="profile-info-item">
                                  <span className="profile-info-title">
                                    Scheduled for
                                  </span>
                                  <p>{jobs.job?.accountInfo?.email || "-"}</p>
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                        {/* Notification List */}
                        {activeTab === "client" && (
                          <>
                            <div className="quote-profile">
                              <div className="d-flex align-items-center g-12">
                                <div>
                                  <h4 className="mb-0 text-lg text-capitalize">
                                    {jobs.job?._creator?.accountInfo?.username}
                                  </h4>
                                  <div className="client-details">
                                    <span className="text-sm text-gray-500">
                                      {jobs.job?.accountInfo?.email}
                                    </span>
                                  </div>
                                  <p className="text-sm text-gray-600">
                                    <button
                                      onClick={handleClientIdCopy}
                                      className="badge copyCode-btn"
                                    >
                                      {jobs?.client?.short_id?.toUpperCase() ||
                                        "PQAZ8VQ"}

                                      {copiedClientId ? (
                                        <CopySuccessIcon />
                                      ) : (
                                        <CopyIcon />
                                      )}
                                    </button>
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex align-items-center g-12 ms-auto">
                                <button
                                  className="btn-outline-light icon-with-btn"
                                  onClick={(e) =>
                                    toScreen(
                                      e,
                                      navigate,
                                      "/message/" +
                                        jobs.job?._creator?.short_id,
                                      false,
                                      {
                                        receiverId: jobs.job?._id,
                                        receiverShortId:
                                          jobs.job?._creator?.short_id,
                                        receiverType: jobs.job?.userType,
                                        userShortId1: "admin",
                                        userShortId2: jobs.job?.short_id,
                                        username2:
                                          jobs.job?.accountInfo?.username,
                                        selectedPage:
                                          window.history.jobs.usr
                                            ?.selectedPage ?? 1,
                                        selectedFilter:
                                          window.history.jobs.usr
                                            ?.selectedFilter ??
                                          defaultMessagesFilter,
                                        previousPath:
                                          window.history.jobs.usr
                                            ?.previousPath ??
                                          window.location.pathname,
                                      },
                                    )
                                  }
                                >
                                  <MessageIcon />
                                  {jobs.job?.accountInfo?.firstname}
                                </button>
                                <button
                                  className="btn-outline-light icon-with-btn"
                                  onClick={(e) =>
                                    toScreen(
                                      e,
                                      navigate,
                                      `/client/${jobs.job?._creator?.short_id}`,
                                    )
                                  }
                                >
                                  Details
                                </button>
                              </div>
                            </div>
                            <div className="p-24">
                              <ul className="profile-info">
                                <li className="profile-info-item">
                                  <span className="profile-info-title">
                                    Email
                                  </span>
                                  <p>{jobs.job?._creator?.email || "-"}</p>
                                </li>
                                <li className="profile-info-item">
                                  <span className="profile-info-title">
                                    Phone
                                  </span>
                                  <p>{jobs.job?._creator?.phone || "-"}</p>
                                </li>
                                <li className="profile-info-item">
                                  <span className="profile-info-title">
                                    Jobs
                                  </span>
                                  <p>{jobs.job?._creator?.jobs || "-"}</p>
                                </li>
                                <li className="profile-info-item">
                                  <span className="profile-info-title">
                                    Registered
                                  </span>
                                  <p>{jobs.job?._creator?.registered || "-"}</p>
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <AuditNotes
                    ref={ref}
                    notes={jobs.job?.notes}
                    updateNotes={updateNotes}
                  />
                </section>

                {jobs.job?.jobSpec?.images?.length != 0 ? (
                  <div className="c-hr"></div>
                ) : (
                  ""
                )}

                <MavSelectComponent
                  ref={mavSelectComponentRef}
                  selectMav={selectMav}
                  currentMav={jobs.selectedMav}
                  userDetails={userDetails}
                />
              </>
            </div>
          </div>
        </>
      )}
    </>
  );
};

Job.contextTypes = {
  router: PropTypes.object,
};

Job.propTypes = {
  userDetails: PropTypes.object.isRequired,
  updateState: PropTypes.func.isRequired,
};

export default withNavigate(Job);
